//
//  SDKRichTextSpan.ts
//  Supernova
//
//  Created by Jiri Trecak.
//
// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// MARK: - Imports
import { RichTextSpanAttribute, } from "./SDKDocumentationLegacyRichTextSpanAttribute";
// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// MARK: -  Object Definition
export class RichTextSpan {
    // --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
    // MARK: - Constructor
    constructor(model) {
        this.text = model.text;
        this.attributes = model.attributes.map((a) => new RichTextSpanAttribute(a));
    }
}
